import OneTrustNotice from "presentation/components/OneTrustNotices/OneTrustNotice";

const TaxPolicy = () => (
  <OneTrustNotice
    noticeUrl="https://privacyportal-cdn.onetrust.com/7bc4e376-ade0-4069-b447-79b713984a3b/privacy-notices/d6a96394-22e5-4482-8996-c6986e4692fe.json"
    noticeId="otnotice-d6a96394-22e5-4482-8996-c6986e4692fe"
  />
);

export default TaxPolicy;
